import React, {useEffect, useState} from 'react';
import {
  Grid, 
  TextField, Stepper, Step, IconButton, Tooltip, InputAdornment,
  Paper, Typography, Autocomplete, Box,
  Button, MenuItem, InputLabel,Select, FormControl, 
} from '@mui/material';


import { useSelector,useDispatch } from 'react-redux';
import {  
  selectAllReasonIds,
  selectAllReasons,
  selectReasonById,
  fetchAllReasons,
  createReason,
  updateReason,
  deleteReason,
  selectReasonIdsByFilter,
}  from '../../store/reasonSlice'

import DeleteIcon from '@mui/icons-material/DeleteForever';
import EditIcon from '@mui/icons-material/AutoFixHigh';


import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';

import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Avatar from '@mui/material/Avatar';


import { format, set } from 'date-fns';

import {useAppAuthContext} from '../../utils/AppAuthContext'

import {usePlayContext} from '../../utils/PlayContext';

import { Navigate, useLocation, useNavigate, useParams } from 'react-router-dom';


import ConfirmDialog from '../../components/ConfirmDialog';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';

import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';
import { KeyTwoTone } from '@mui/icons-material';



const ReasonDialog = (props) => {
  const {
    op, setOp, setStatus, setErrorMessage,
    nid, setNid,
   openSnackToast
  }=usePlayContext()

  const dispatch = useDispatch()
  const [reason, setReason] = useState(nid?.reason)
  const [reasonError, setReasonError] = useState('')


  const allReasons = useSelector(selectAllReasons)

  let myttile = '', mylabel='', mysize='lg'

  if (op==='add'){
    myttile = mylabel = 'Create'
  } 
  else    if (op==='edit'){
    myttile = 'Edit'
    mylabel='Update'
  } 
  else if (op==='delete')
  {
    myttile = mylabel = 'Delete'

  }

    const doDelete= async(id)=>
    {
        setStatus('loading')
        try
        {
            let xx = dispatch(deleteReason(id)).unwrap();
            setStatus('idle')
        }
        catch (ex)
        {
            console.error(ex)
            setErrorMessage("Error during deletion")
            setStatus('error')
        }

        setOp('')
        setNid(null)

    }
  
    const doCommit=async()=>
    {

      if ('delete'==op)
      {
          await doDelete(nid.id);     
          return;
      }

      //alert(1111)
      if (!Boolean(reason) || !Boolean(reason.trim()))
      {
          setReasonError('Purpose of Visit cannot be empty')
          return;
      }
      
      
      
      let reason1=reason.toLowerCase()

      let xx = allReasons.find(x=> x.reason.toLowerCase()===reason1)
            

      if (xx)
      {
          if (op==='add')
          {
              setReasonError('Purpose of Visit already exists')
              return;
          }
          else
          {
              if (xx.id!==nid.id)
              {
                setReasonError('Purpose of Visit already exists')
                return;
              }
  
          }
      }

      
        setStatus('idle')
        try
        {

          if (op==='add')
          {
              await dispatch(createReason({reason})).unwrap();
          }
          else
          {
            await dispatch(updateReason(
              {
                reason,
                id:nid.id
              })
              
              ).unwrap();
          }
          setStatus('idle')

          
        }
        catch (ex)
        {
            console.error(ex)
            setErrorMessage("Error during reason "+ (op==='add'? 'creation':'update'));
            setStatus('error')
        }

        setOp('')
        setNid(null)

    }
  return (
    <Dialog 
        open={Boolean(op)}
        
        maxWidth={mysize}
        onClose={e => setOp('')}>
      <DialogTitle sx={{}}><small>{myttile}&nbsp;Purpose of Visit</small></DialogTitle>
      <DialogContent>
        <Box sx={{p:1, mx:0, border:0, borderColor:'#999999', borderRadius:3, maxWidth:900, minWidth:600}}>

          {
            op==='delete' &&
              <Typography variant='h6' textAlign='center' sx={{color:'primary.main'}}>
                Are you sure to delete the item?
                </Typography>
          }
          {
            (op==='edit' || op==='add') &&
              <TextField 
                size='small'
                required
                fullWidth
                error={Boolean(reasonError)}
                value={reason}
                id="id_remarks" label="Purpose of Visit" type="text" 
                onChange = { e=>setReason(e.target.value)}
                inputProps={{ maxLength: 100,  }}
                helperText={ reasonError}/>

          }
          </Box>
      </DialogContent>
         
      <DialogActions sx={{m:0,pb:2}}>
        <Box sx={{display:'flex', justifyContent:'space-around', width:'88%'}}>
            <Button variant="outlined" autoFocus size='small' color='success'
                onClick={doCommit}
                disabled={!Boolean(reason) || !Boolean(reason.trim())}
                >
                {mylabel}
            </Button>
            <Button variant="outlined"  color='primary'
                onClick={e=>{setNid(null); setOp("")}}
                color='success' 
                size='small'>
              Cancel
            </Button>
        </Box>
      </DialogActions>
     </Dialog>
  );
};


const ReasonTableHeader=()=>{

  return (
        <TableHead>
                <TableRow sx={{bgcolor:'#98DDFF'}}>
                    <TableCell align="center" style={{border: '1px solid LightGray', fontWeight: 600}}>PURPOSE OF VISIT</TableCell>
                    
                    <TableCell align="center" style={{border: '1px solid LightGray', fontWeight: 600}}>ACTIONS</TableCell>
                    
                  </TableRow>
      </TableHead>

  )
}

const ReasonTableRow=({id, index})=>
{
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const {
      op, setOp,
      nid, setNid,
     openSnackToast
    }=usePlayContext()
    const row = useSelector(  selectReasonById(id))


    const deteteRow= ()=>{
        if (id && row)
        {
          setNid(row)
          setOp('delete')
        }
    }
    const editRow =()=>{
      if (id && row)
      {
        setNid(row)
        setOp('edit')
  
      }

    }


    return(
      <TableRow>
        <TableCell  style={{border: '1px solid LightGray', whiteSpace:'nowrap', width:'85%'}}>
            {row.reason}
        </TableCell>
        <TableCell  style={{border: '1px solid LightGray', whiteSpace:'nowrap'}}>
            <Box sx={{display:'flex', justifyContent:'space-around', flexDirection:'row', m:0, p:0}} >
              <IconButton size='small' color='primary'
                  onClick={editRow}
                  >
                  <EditIcon size='small'/>
              </IconButton>
              <IconButton size='small' color='primary'
                onClick={deteteRow}
              ><DeleteIcon size='small'/></IconButton>
            </Box>
        </TableCell>
  </TableRow>

    )


}



const ReasonPage = () => {

    const navigate = useNavigate()
    const dispatch = useDispatch()




    const {userInfo, managedHosts} = useAppAuthContext()
  
    const {
      op, setOp,
      nid, setNid,
      status, setStatus, setAppTitle, 
      setErrorMessage,  setErrorTitle,
      setTenantLogo, openSnackToast
    }=usePlayContext()


    const [keyword, setKeyword]=useState('');
  
    const allReasonIds = useSelector(state=>selectReasonIdsByFilter(state, keyword))
  
    const addReason = ()=>{
      setOp('add')
          
      setNid(null)
        //alert(123)

    } 

    useEffect(() => {
      setAppTitle(  ['Administration','Purpose of Visit', ])
      setErrorMessage('')
      setErrorTitle('')

      setOp('')
      setNid(null)
      
      return () => {

      }

  }, [])

  
  

  return (
    <Box sx={{p:1}}>
        <Card sx={{width:'100%',  pt:2, mb:1, pb:0}} raised>
            
        <CardContent sx={{my:0, py:1}}>
        <Grid
          container 
          spacing={1}
          direction={'row'}
          columns={12}
        >
       
             <Grid item xs={12} sm={6}  md={4} >
              <Autocomplete 
                fullWidth
                size='small'
                freeSolo
                selectOnFocus
                handleHomeEndKeys
                //disableClearable
                id="id_reason" 
                value={keyword}
                options={[]} 
                onInputChange={(e,n)=>setKeyword(n)}
                renderInput={(params) => 
                    <TextField {...params} 
                      
                      label="Search Key Word"  
                      />}
                />
              </Grid>
            <Grid item xs={12} sm={6} md={8} sx={{  }}>
              <Box sx={{mt:1,display:'flex', width:'100%', justifyContent: 'space-between'}}>

                  <Button variant="outlined"  color='info'  
                    onClick={e=>setKeyword('')}
                  > Clear</Button>

                  <Button variant="outlined"  color='primary'  
                    onClick={addReason}
                  > Add</Button>
              </Box>
          </Grid>                          
        </Grid>

        </CardContent>
        </Card>
          <TableContainer component={Paper} >
            <Table  size='small' >
              <ReasonTableHeader/>
                <TableBody>
                  { allReasonIds && allReasonIds.length>0 &&
                      allReasonIds.map((id, i)=>

                        <ReasonTableRow key={id} id={id}/> 
                      )
                  }
              </TableBody>
            </Table>
        </TableContainer>
        
        {Boolean(op)&& 
        <ReasonDialog />
        }
      </Box>
  );
};


export default ReasonPage;
